
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import { useProfileShow } from '@/composables/user/user'
import useProfileMenu, {
  useProfileMenuChange,
} from '@/composables/profile/profileMenu'
import ProfileMenuItem from '@/components/Profile/Menu/ProfileMenuItem.vue'
import ProfileSubMenuItem from '@/components/Profile/Menu/ProfileSubMenuItem.vue'

export default defineComponent({
  name: 'UserProfileMenu',
  components: { ProfileSubMenuItem, ProfileMenuItem, AButton },
  data() {
    return {
      activeCarousel: false,
      activeFirstItem: false,
      activeLastItem: false,
    }
  },
  methods: {
    isCarouselActive() {
      const carousel: any = this.$refs.carousel
      const carouselWrapper: any = this.$refs.carouselWrapper

      if (
        typeof carousel === 'undefined' &&
        typeof carouselWrapper === 'undefined'
      ) {
        return false
      }

      return (this.activeCarousel =
        carouselWrapper.scrollWidth > carousel.clientWidth)
    },

    moveToPrevSlide() {
      const carousel: any = this.$refs.carousel
      const allVisibleItems = carousel.querySelectorAll('.item-visible')
      const firstVisibleItem = allVisibleItems[0]
      const prevItem = firstVisibleItem.previousElementSibling

      if (prevItem !== null) {
        prevItem.classList.add('item-visible')

        carousel.scroll({
          left: prevItem.offsetLeft,
          behavior: 'smooth',
        })
      }
    },

    initSlider() {
      const carousel: any = this.$refs.carousel
      const carouselWrapper: any = this.$refs.carouselWrapper
      const currentActivePage = useProfileMenu().activePage.value
      const carouselItems: any = carouselWrapper.querySelectorAll(
        '.anz-tabs-carousel__item'
      )

      function getActiveItem() {
        carouselItems.forEach((item: any) => {
          const itemId = item.getAttribute('id')
          if (itemId === currentActivePage) {
            item.classList.add('item-visible')

            carousel.scrollLeft = item.offsetLeft
          }
        })
      }

      if (document.readyState === 'complete') {
        getActiveItem()
      } else {
        window.addEventListener('load', function() {
          getActiveItem()
        })
      }
    },

    moveToNextSlide() {
      const carousel: any = this.$refs.carousel
      const allVisibleItems = carousel.querySelectorAll('.item-visible')
      const lastVisibleItem = allVisibleItems[allVisibleItems.length - 1]
      const nextItem = lastVisibleItem.nextElementSibling

      if (nextItem !== null) {
        const nextItemOffsetRight = nextItem.offsetLeft + nextItem.offsetWidth
        nextItem.classList.add('item-visible')

        carousel.scroll({
          left: nextItemOffsetRight - carousel.clientWidth,
          behavior: 'smooth',
        })
      }
    },

    setVisibleSlides() {
      const carouselWrapper: any = this.$refs.carouselWrapper
      const carouselItems: any = carouselWrapper.querySelectorAll(
        '.anz-tabs-carousel__item'
      )

      carouselItems.forEach((item: any) => {
        const observer = new IntersectionObserver(
          entries => {
            if (entries[0].isIntersecting) {
              item.classList.add('item-visible')

              this.activeFirstItem = !carouselItems[0].classList.contains(
                'item-visible'
              )

              this.activeLastItem = !carouselItems[
                carouselItems.length - 1
              ].classList.contains('item-visible')
            } else {
              item.classList.remove('item-visible')
            }
          },
          { threshold: [1] }
        )

        observer.observe(item)
      })
    },

    setCarouselDraggable() {
      const carousel: any = this.$refs.carousel
      let mouseDown = false
      let startX: any
      let scrollLeft: any
      let touchStartX: any

      if (carousel !== null) {
        const startDragging = (e: any) => {
          mouseDown = true
          startX = e.pageX - carousel.offsetLeft
          scrollLeft = carousel.scrollLeft
        }

        const startTouchDragging = (e: any) => {
          mouseDown = true
          touchStartX = e.changedTouches[0].pageX - carousel.offsetLeft
          scrollLeft = carousel.scrollLeft
        }

        const stopDragging = () => {
          mouseDown = false
        }

        carousel.addEventListener('mousemove', function(e: any) {
          e.preventDefault()

          if (!mouseDown) {
            return
          }

          const x = e.pageX - carousel.offsetLeft
          const scroll = x - startX

          carousel.scrollLeft = scrollLeft - scroll
        })

        carousel.addEventListener('touchmove', function(e: any) {
          e.preventDefault()

          if (!mouseDown) {
            return
          }

          const x = e.changedTouches[0].pageX - carousel.offsetLeft
          const scroll = x - touchStartX

          carousel.scrollLeft = scrollLeft - scroll
        })

        carousel.addEventListener('mousedown', startDragging, false)
        carousel.addEventListener('mouseup', stopDragging, false)
        carousel.addEventListener('mouseleave', stopDragging, false)

        carousel.addEventListener('touchstart', startTouchDragging, false)
        carousel.addEventListener('touchend', stopDragging, false)
        carousel.addEventListener('touchcancel', stopDragging, false)
      }
    },
  },
  mounted() {
    this.initSlider()
    this.setVisibleSlides()
    this.setCarouselDraggable()

    this.isCarouselActive()

    window.addEventListener('resize', () => {
      this.isCarouselActive()
    })
  },
  setup() {
    return {
      ...useProfileMenuChange(),
      ...useProfileShow(),
      ...useProfileMenu(),
    }
  },
})
